import { throttle } from '@theme/utilities';

class ArticleNavigation extends HTMLElement {
    connectedCallback() {
        this.heightSet = false;
        window.addEventListener("scroll", throttle(this.updateProgressBar.bind(this), 15));
    }

    get hasNextArticle() {
        return this.hasAttribute("has-next-article");
    }

    setHeight() {
        document.documentElement.style.setProperty(
            '--article-navigation-height',
            `${parseInt(this.getBoundingClientRect().height)}px`
        );

        this.heightSet = true;
    }

    updateProgressBar() {
        if (!this.heightSet) this.setHeight();

        const stickyHeaderOffset = this.getStickyHeaderOffset(),
            marginCompensation = window.innerWidth < 990 ? 40 : 80,
            articleNavBoundingBox = this.getBoundingClientRect(),
            articleMainPartBoundingBox = this.parentElement.getBoundingClientRect(),
            difference = articleMainPartBoundingBox.bottom - (articleNavBoundingBox.bottom - marginCompensation),
            progress = Math.max(-1 * (difference / (articleMainPartBoundingBox.height + marginCompensation) - 1), 0);
        this.classList.toggle("is-visible", articleMainPartBoundingBox.top < stickyHeaderOffset && articleMainPartBoundingBox.bottom > stickyHeaderOffset + this.clientHeight - marginCompensation);
        if (this.hasNextArticle) {
            if (progress > 0.8) {
                this.classList.add("article__nav--show-next");
            } else {
                this.classList.remove("article__nav--show-next");
            }
        }
        this.style.setProperty("--transform", `${progress}`);
    }

    getStickyHeaderOffset() {
        let headerComponent = document.querySelector('header-component');
        if (headerComponent) {
            return headerComponent.initHeaderPositions();
        } else {
            return 0;
        }
    }
};

if (!customElements.get('article-navigation')) {
  customElements.define('article-navigation', ArticleNavigation);
}